import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "strengths-list-pair" }
const _hoisted_2 = { class: "col-md-4 col-xs-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "strengths-list-title-box" }, "Solo", -1)
const _hoisted_4 = { class: "strengthList strengths-list-inner text-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "cs-accordion-anchor-child" }
const _hoisted_7 = { class: "col-md-4 col-xs-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "strengths-list-title-box" }, "Viewpoints", -1)
const _hoisted_9 = { class: "strengthList strengths-list-inner text-center" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "cs-accordion-anchor-child" }

import { ref } from "vue";
import { StrengthItemRatingApiModel } from "../../api-models";
import { DEFAULT_RATINGS, fontClass } from "./strengths-list-helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'strengths-list-pair',
  props: {
    soloRatings: { default: () => DEFAULT_RATINGS },
    viewpointsRatings: { default: () => DEFAULT_RATINGS }
  },
  setup(__props: any) {

const props = __props;

const activeStrength = ref("");

function click(name: string): void {
  if (activeStrength.value === name) {
    activeStrength.value = "";
  } else {
    activeStrength.value = name;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ol", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.soloRatings, (rating, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: rating.strength.name
          }, [
            _createElementVNode("a", {
              onClick: ($event: any) => (click(rating.strength.name)),
              href: "javascript:void(0)",
              class: _normalizeClass(["a-block cs-accordion-anchor a-unstyled strengths-list-item-anchor", [
              _unref(fontClass)(index),
              activeStrength.value === rating.strength.name ? 'active' : activeStrength.value ? 'inactive' : '',
            ]])
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(rating.strength.name), 1)
            ], 10, _hoisted_5)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("ol", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewpointsRatings, (rating, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: rating.strength.name
          }, [
            _createElementVNode("a", {
              onClick: ($event: any) => (click(rating.strength.name)),
              href: "javascript:void(0)",
              class: _normalizeClass(["a-block cs-accordion-anchor a-unstyled strengths-list-item-anchor", [
              _unref(fontClass)(index),
              activeStrength.value === rating.strength.name ? 'active' : activeStrength.value ? 'inactive' : '',
            ]])
            }, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(rating.strength.name), 1)
            ], 10, _hoisted_10)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})